import { METHOD_AXIOS } from '../utils/constant'
import { BaseApi } from './base.api'

export class AuthenticationApi extends BaseApi {
	constructor() {
		super('')
	}

	async logOut() {
		const rs = await this.post('api/logout')
		return rs
	}

	async logIn(data) {
		const rs = await this.methodWithFormDataUrlEncoded(
			'login',
			data,
			METHOD_AXIOS.POST
		)
		return rs
	}
}
